import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "reactstrap";

import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import { formatDate } from "../../../utils/formatDate";
import { listarNotasDoPedido } from "../../../services/pedidosApi";

// Notas do pedido (linha aberta da tela de Pedidos). Extraído de Pedido/index.js
// na PO1-3500 para o modal do pedido no quadro do despacho reaproveitar a mesma
// tabela. Com `onAbrirNota`, a ação da linha abre o detalhe da NF-e (modal) em
// vez de levar ao Rastreamento.

// Status da NF (regra canônica) na linha aberta do pedido.
const TOM_DO_STATUS_NF = {
  entregue: "success",
  devolvida: "pink",
  atrasada: "pink",
  em_transito: "info",
  pendente: "neutral",
  sem_previsao: "warning",
  retirada: "success",
  entrega_propria: "info",
  despachado: "info",
  etiqueta_emitida: "neutral",
};

const fmtData = (v) => (v ? formatDate(v) : null);

const NotasDoPedido = ({ pedido, paramsRecorte, onAbrirNota }) => {
  const [notas, setNotas] = useState(null);
  const [erro, setErro] = useState("");

  useEffect(() => {
    let cancelado = false;

    async function carregar() {
      setNotas(null);
      setErro("");
      try {
        const data = await listarNotasDoPedido({ ...paramsRecorte, pedido });
        if (!cancelado) setNotas(data);
      } catch (_) {
        if (!cancelado) {
          setNotas([]);
          setErro("Não conseguimos carregar as notas deste pedido.");
        }
      }
    }

    carregar();
    return () => {
      cancelado = true;
    };
  }, [pedido, paramsRecorte]);

  if (notas === null) {
    return (
      <div className="pedidos__notas-estado">
        <Spinner size="sm" style={{ color: AUTOPILOT_COLORS.accent }} /> Carregando notas...
      </div>
    );
  }

  if (erro) {
    return <div className="pedidos__notas-estado pedidos__notas-estado--erro">{erro}</div>;
  }

  return (
    <table className="pedidos__notas">
      <thead>
        <tr>
          <th>Nota fiscal</th>
          <th>Emissão</th>
          <th>Transportadora</th>
          <th>Previsão</th>
          <th>Entrega</th>
          <th>Status</th>
          <th>Última ocorrência</th>
          <th aria-label="Ações" />
        </tr>
      </thead>
      <tbody>
        {notas.map((nf) => (
          <tr key={nf.id}>
            <td>
              <strong>{nf.numero}</strong>
              {nf.serie ? <small>Série {nf.serie}</small> : null}
            </td>
            <td>{fmtData(nf.data_emissao) || "-"}</td>
            <td title={nf.transportadora || ""}>{nf.transportadora || "-"}</td>
            <td>{fmtData(nf.previsao_entrega) || <span className="pedidos__muted">Sem previsão</span>}</td>
            <td>{fmtData(nf.entrega) || <span className="pedidos__muted">-</span>}</td>
            <td>
              <span
                className={`pedidos__status pedidos__status--${TOM_DO_STATUS_NF[nf.status] || "neutral"}`}
              >
                {nf.status === "atrasada" && nf.semRetorno
                  ? "Atrasada · sem retorno"
                  : nf.statusLabel}
              </span>
            </td>
            <td title={(nf.ultimaOcorrencia && nf.ultimaOcorrencia.nome) || ""}>
              {nf.ultimaOcorrencia ? (
                nf.ultimaOcorrencia.nome
              ) : (
                <span className="pedidos__muted">Sem ocorrência registrada</span>
              )}
            </td>
            <td className="pedidos__acao">
              {onAbrirNota ? (
                // Dentro de modal (quadro do despacho): o detalhe abre em outro modal, sem sair da tela.
                <button type="button" className="pedidos__acao-botao" onClick={() => onAbrirNota(nf.id)}>
                  NF-e
                </button>
              ) : (
                <Link to={`/app/trackfy/operacao/rastreamento?idNf=${nf.id}`}>Rastrear</Link>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default NotasDoPedido;
